<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
            <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
            <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>

            <v-dialog persistent max-width="400px">
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">
                            <v-toolbar-title>{{$t('Accounting-Code-Transfer')}}</v-toolbar-title>

                        </v-toolbar>
                    </v-flex>
                    <v-card-text>
                        <v-layout row="" wrap>
                            <div class="flex md12">

                                <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                    <input hidden type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
                                </v-form>

                                <v-layout>
                                    <v-text-field disabled="" :label="$t('XSLT-File-Name-E-Invoice')" :placeholder="dosya1mesaj" v-model="dosyayolu1">
                                    </v-text-field>
                                    <v-btn color="info" @click="addFiles()">
                                        <v-icon>attach_file</v-icon> {{ $t('Select-File') }}
                                    </v-btn>
                                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                        <span> {{ $t('Select-File') }}</span>
                                    </v-tooltip>
                                </v-layout>

                                <v-layout>

                                </v-layout>

                            </div>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>

                        <v-tooltip bottom>
                            <v-btn slot="activator" :disabled="file.length==0" id="bkaydet" color="blue darken-1" flat @click="DosyalariYukle()"> {{ $t('Upload-Files') }}
                            </v-btn>

                            <span> {{ $t('Upload-Files') }} </span>
                        </v-tooltip>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog scrollable="" persistent v-model="dialog" max-width="450px">
                <v-card flat color="grey lighten-5">
                    <v-toolbar size="120px" color="info">
                        <v-toolbar-title class="white--text">{{$t('Accounting-Code-Transfer')}}</v-toolbar-title>
                        <v-spacer></v-spacer>

                    </v-toolbar>
                    <v-card-text>

                        <v-flex pb-2 xs12 sm12 md12>
                            <v-card flat class="white--text">
                                <v-card color="white" flat="">
                                    <v-card-actions>

                                        <v-layout row="" wrap="">
                                            <v-flex v-if="file.length==0" xs12 sm12 md12>
                                                <v-alert type="error" value="true">
                                                    <span v-if="file.length==0">{{$t('Please-select-file')}}</span>
                                                </v-alert>
                                            </v-flex>
                                            <v-form ref="formek" v-model="valid" lazy-validation>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                                <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="file" ref="file" multiple v-on:change="handleFileUpload2()" />
                                                            </v-form>
                                                            <v-btn flat :loading="false" :disabled="false" color="info" @click="addFiles()">
                                                                <v-icon color="info" left>attach_file
                                                                </v-icon>{{$t('Select-File')}}
                                                            </v-btn>
                                                        </v-flex>

                                                        <v-flex pt-2 pl-2 pb-2 v-if="file.length>0" xs12 sm12 md8>
                                                            <span>{{file.length}}  {{$t('pcs-of-files-selected')}}</span>
                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout fill-height align-center>
                                                                <span class="grey--text title">
                                                                    {{ secilendosya}}</span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <ul id="ulList">
                                                        </ul>

                                                        <v-flex xs12 pt-2 sm12 md12>
                                                            <v-layout justify-end>

                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-flex>
                                            </v-form>

                                        </v-layout>

                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog = false">
                            {{$t('Close')}} </v-btn>

                        <v-btn flat @click="DosyalariYukle()" color="info">{{$t('Upload-Files')}}
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">{{$t('Definitions-v2')}}</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
                <v-container fluid>
                    <v-layout row="" wrap="">
                        <router-link :to="{ name: 'sirket' }">
                            <v-btn style="width:200px" color="info" dark> {{$t('Company')}}
                                <v-icon right dark>business_center</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'evrak' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Document')}}
                                <v-icon right="" dark>question_answer</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'referans' }">
                            <v-btn style="width:200px" color="info" dark> {{$t('Reference')}}
                                <v-icon right dark>timeline</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'doviz' }">
                            <v-btn style="width:200px" color="info" dark> {{$t('Currency')}}
                                <v-icon right dark>call_to_action</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'masrafmerkezi' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Expense-Center-v2')}}
                                <v-icon right dark>attach_money</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'firma' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Company-Card')}}
                                <v-icon right dark>credit_card</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'analiz' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Analysis')}}
                                <v-icon right dark>trending_up</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'bankapos' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Bank-POS')}}
                                <v-icon right dark>call_to_action</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'banka' }">
                            <v-btn style="width:200px" color="info" dark> {{$t('Bank')}}
                                <v-icon right dark>account_balance</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'bolum' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Department-Code-Bolum')}}
                                <v-icon right dark>web</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'gib' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark> {{$t('Turkish-Revenue-Administration-Serial-No')}}
                                <v-icon right dark>web</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'gibseriearsiv' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark>{{$t('Turkish-Serial-No-E-archive')}}
                                <v-icon right dark>web</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'hesapgurubu' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('Account-Group')}}
                                <v-icon right dark>web</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'efaturadip' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark> {{$t('E-invoice-Footer-Disclosure')}}
                                <v-icon right dark>web</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'webadresi' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark>{{$t('Add-Web-Address')}}
                                <v-icon right dark>web_asset</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'odemearaci' }" v-if="PB=='TRY'">

                            <v-btn style="width:200px" color="info" dark>{{$t('Add-Payment-Instrument')}}
                                <v-icon right="" draggable="">payment</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'odemesekliaciklama' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark> {{$t('Payment-Method-Description')}}
                                <v-icon right dark>credit_card</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'istisnaaciklama' }" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark>{{$t('Exception-Code')}}
                                <v-icon right dark>next_week</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'kdvoranhesap' }">
                            <v-btn style="width:200px" color="info" dark>{{$t('VAT-Rate-and-Calculations')}}
                                <v-icon right dark>calculate</v-icon>
                            </v-btn>
                        </router-link>

                        <v-btn style="width:200px" @click.native="dialog=true" color="info" dark>{{$t('Accounting-Code-Transfer')}}
                            <v-icon right dark>attach_file</v-icon>
                        </v-btn>

                        <router-link :to="{ name: 'geneltanitim' , params: { id: 302 }}" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark> {{ $t('Withholding-Code') }}
                                <v-icon right dark>card_membership</v-icon>
                            </v-btn>
                        </router-link>

                        <router-link :to="{ name: 'geneltanitim' , params: { id: 301 }}" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark> {{ $t('Transfer-Code') }}
                                <v-icon right dark>credit_score</v-icon>
                            </v-btn>
                        </router-link>

                         <router-link :to="{ name: 'geneltanitim' , params: { id: 303 }}" v-if="PB=='TRY'">
                            <v-btn style="width:200px" color="info" dark>{{$t('VAT-Code')}}
                                <v-icon right dark>account_balance</v-icon>
                            </v-btn>
                        </router-link>

                    </v-layout>
                </v-container>

            </v-layout>
        </v-card>
    </v-app>

</div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import axios from 'axios'
import auth from '../../../api/auth'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp"
import loadingcomp from "@/components/app/customcomp/loadingcomp"

export default {
    data() {
        return {
            PB:"TRY",
            file: [],
            dosyayolu1: null,
            loadingvmodel: false,
            text1: null,
            snackbar: false,
            secilendosya: null,
            tooltip: false,
            el: null,
            valid: true,
            dialog: false,
            dosya1mesaj: null,
            yenikayit: false,

            dosyaokearsiv: false,
            dosyaokefatura: false,

            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    beforeMount: beforeMount,
    components: {
        yetkidialog,
        snackbarcomp,
        loadingcomp
    },
    mounted() {

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
        var cred = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=cred.ParaBirimi
        if (this.sayfayetki.Status == true) {

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        let url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        let url = '#/'
                        window.open(url, '_self')
                    }
                }

            });

        }
    },
    watch: {

    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    },
    methods: {
        addFiles() {
            this.$refs.file.click();
        },

        handleFileUpload2() {
            this.file = []

            if (this.$refs.file.files != [] && this.$refs.file.files != null) {
                var uploadedFiles = this.$refs.file.files;

                var fp = document.getElementById('file');

                var lg = uploadedFiles.length; // get length
                if (lg > 0) {
                    this.dosya1mesaj = lg +  " " + this.$t('pcs-of-files-selected')
                } else {
                    this.dosya1mesaj = this.$t('file-has-been-chosen')
                }
                document.getElementById('ulList').innerHTML = '';

                var items = uploadedFiles
                var fragment = "";

                if (lg > 0) {
                    for (var i = 0; i < lg; i++) {
                        var fileName = items[i].name; // get file name
                        var fileSize = items[i].size; // get file size
                        var fileType = items[i].type; // get file type

                        // append li to UL tag to display File info
                        fragment += "<li>" + fileName + " (<b>" + fileSize +
                            "</b> bytes)" // + "- Type :" + fileType + "</li>";
                    }
                    document.getElementById('ulList').innerHTML = fragment;
                    //contentWindow.document.body.innerHTML = response.body;
                    // $("#ulList").append(fragment);
                }

                if (uploadedFiles.length > 0) {

                    for (var i = 0; i < uploadedFiles.length; i++) {
                        this.file.push(uploadedFiles[i]);
                    }

                } 
            }

        },
        DosyalariYukle() {
            var cred = JSON.parse(window.localStorage.getItem('credentials'));

            if (this.file.length > 0) {
                this.loadingvmodel = true
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i + ']', file);
                    formData.append('CustomerCode', cred.AnaSirketKodu)
                    formData.append('CompanyCode', cred.SirketKodu)
                    axios.defaults.baseURL = auth.API_URL;
                    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    axios.post(auth.API_URL + 'api/Definitions/FileUploadAccountingStream',
                            formData, {
                                headers: {
                                    Authorization: `Bearer ${auth.getAuthHeader()}`
                                }
                            }
                        ).then((response) => {

                            if (response.data === true) {

                                var params3 = {
                                    CustomerCode: cred.AnaSirketKodu,
                                    CompanyCode: cred.SirketKodu
                                }

                                this.$http.post(auth.API_URL + 'api/Definitions/AccountingCodeStream',
                                    params3, {
                                        headers: {
                                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                                        }
                                    }).then((response) => {
                                    if (!response.body[0].Status) {
                                        this.dialog = false
                                        this.text1 = response.body[0].Aciklama
                                        this.snackbar = true
                                        this.loadingvmodel = false
                                    } else {
                                        this.dialog = false
                                        this.text1 = this.$t('File-transfer-completed')
                                        this.snackbar = true
                                        this.loadingvmodel = false
                                    }

                                }, (response) => {
                                    this.loadingvmodel = false
                                    if (response.status === 0) {
                                        this.progress = false
                                        this.text1 = 'Service Unavailable-AccountingCodeStream'
                                        this.snackbar = true
                                    } else {
                                        this.text1 = 'Service Unavailable-AccountingCodeStream'
                                        this.snackbar = true
                                    }
                                })
                            } else {
                                this.text1 = this.$t('Error-in-file-transfer-try-again')
                                this.snackbar = true
                                this.loadingvmodel = false
                            }
                        })
                        .catch(function () {
                            this.loadingvmodel = false
                            this.text1 = this.$t('Error-in-file-transfer-try-again')
                            this.snackbar = true

                        });
                }
            }
        }

    }
}

function beforeMount() {}
</script>
